import { createReducer, on } from '@ngrx/store';

import { IOrderFillDetail } from '@ruby/modules/order-fill/model/order-fill.interface';
import * as OrderFillActions from '@ruby/modules/order-fill/store/actions/order-fill.actions';
import { IError } from '@ruby/shared/models/request/error.interface';

export const featureKey = 'order-fill';

export interface State {
  loading: boolean;
  error?: IError;
  requested: number;
  accepted: number;
  filled: number;
  notAccepted: number;
  acceptedNotFilled: number;
  metrics: Array<IOrderFillDetail>;
}

export const initialState: State = {
  loading: false,
  error: undefined,
  requested: 0,
  accepted: 0,
  filled: 0,
  notAccepted: 0,
  acceptedNotFilled: 0,
  metrics: []
};

export const reducer = createReducer(
  initialState,
  on(OrderFillActions.loadSummary, state => ({
    ...state,
    loading: true,
    error: undefined
  })),
  on(OrderFillActions.loadSummarySuccess, (state, action) => ({
    ...state,
    loading: false,
    requested: action.data.requested,
    accepted: action.data.accepted,
    filled: action.data.filled,
    notAccepted: action.data.notAccepted,
    acceptedNotFilled: action.data.acceptedNotFilled,
    metrics: action.data.metrics
  })),
  on(OrderFillActions.loadSummaryFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.error
  })),
  on(OrderFillActions.resetState, () => initialState)
);
